import request, { miniFetch } from '../../lib/api/request.js';

// 获取用户作品
// TODO 分页查询
// const requestMyProjects = function(resolve, reject) {
//     return miniFetch(resolve, reject, {
//         url: '/v1/worksLib/list?current=1&size=1000&type=6',
//         method: 'get',
//         mode: 'cors'
//     });
// };
const requestMyProjects = function(resolve, reject, query) {
    return miniFetch(resolve, reject, {
        url: `/v1/worksLib/list?current=${query.current}&size=${query.size}&type=${query.type}`,
        method: 'get',
        mode: 'cors'
    });
};

// 获取单个作品
const requestProjectById = function(resolve, reject, id) {
    return miniFetch(resolve, reject, {
        url: `/v1/worksLib/${id}`,
        method: 'get',
        mode: 'cors'
    });
};

// 修改作品
const putWork = function(resolve, reject, data) {
    return miniFetch(resolve, reject, {
        url: '/v1/worksLib',
        method: 'put',
        mode: 'cors',
        data: data
    });
};

// 上传作品
const uploadWork = function(resolve, reject, data) {
    return miniFetch(resolve, reject, {
        url: '/v1/worksLib',
        method: 'post',
        mode: 'cors',
        data: data
    });
};

// 修改作品名称
const requestUpdateProjectTitle = (resolve, reject, projectId, projectTitle) =>
    miniFetch(resolve, reject, {
        url: `/v1/worksLib`,
        method: 'put',
        mode: 'cors',
        data: {
            id: projectId,
            title: projectTitle
        }
    });

// 删除作品名称
const requestDeleteProject = (resolve, reject, projectId) =>
    miniFetch(resolve, reject, {
        url: `/v1/worksLib?id=${projectId}`,
        method: 'delete',
        mode: 'cors'
    });

export { requestMyProjects, requestProjectById, putWork, uploadWork, requestUpdateProjectTitle, requestDeleteProject };